import Add from "@mui/icons-material/Add";
import Search from "@mui/icons-material/Search";
import { Button, InputAdornment, Stack, TextField } from "@mui/material";

type ChatHistorySearchToolbarProps = {
  searchPlaceholder: string;
  newChatLabel: string;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onNewChat: () => void;
};

export function ChatHistorySearchToolbar({
  searchPlaceholder,
  newChatLabel,
  searchQuery,
  onSearchQueryChange,
  onNewChat,
}: ChatHistorySearchToolbarProps) {
  const searchHeightPx = 56;
  const searchBorderRadiusPx = 10;

  return (
    <Stack
      direction="row"
      alignItems="stretch"
      sx={{ gap: 2 }}
    >
      <TextField
        placeholder={searchPlaceholder}
        value={searchQuery}
        onChange={(event) => onSearchQueryChange(event.target.value)}
        fullWidth
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: "var(--theme-text-secondary)" }} />
              </InputAdornment>
            ),
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            minHeight: searchHeightPx,
            bgcolor: "var(--theme-surface)",
            borderRadius: `${searchBorderRadiusPx}px`,
            "& fieldset": {
              borderColor: "var(--theme-border)",
            },
            "&:hover fieldset": {
              borderColor: "var(--theme-border)",
            },
            "&.Mui-focused fieldset": {
              borderColor: "var(--theme-primary-light)",
            },
          },
          "& .MuiInputBase-input": {
            py: 0,
            boxSizing: "border-box",
            height: searchHeightPx,
          },
          "& .MuiInputBase-input::placeholder": {
            color: "var(--theme-text-secondary)",
            opacity: 1,
          },
        }}
      />
      <Button
        onClick={onNewChat}
        startIcon={<Add />}
        sx={{
          flexShrink: 0,
          minHeight: searchHeightPx,
          px: 2.5,
          borderRadius: `${searchBorderRadiusPx}px`,
          bgcolor: "var(--theme-primary)",
          color: "var(--theme-text-on-primary)",
          textTransform: "none",
          fontWeight: 500,
          whiteSpace: "nowrap",
          "&:hover": {
            bgcolor: "var(--theme-hover-primary, var(--theme-primary-light))",
          },
        }}
      >
        {newChatLabel}
      </Button>
    </Stack>
  );
}
